module.exports = {
    namespace: 'pages',

    da: {
        home: {
            title: 'Forside',
        },

        'groups-overview': {
            title: 'Hvad kan vi lave?',
        },

        students: {
            title: 'Find studerende',
        },

        contact: {
            title: 'Kontakt',
        },

        terms: {
            title: 'Vilkår & Betingelser',
        },

        about: {
            title: 'Om os',
        },

        'new-student': {
            headerTitle: 'Bliv student freelancer',
            title: 'Bliv student freelancer hos Taskflex',
            subtitle: 'Arbejd med det du vil, når du vil, hvor du vil',
        },

        blog: {
            title: 'Blog',
        },

        overview: {
            title: 'Oversigt',
        },

        users: {
            account: {
                title: 'Konto',
            },
            profile: {
                title: 'Profil',
            },
            settings: {
                title: 'Indstillinger',
            },
        },
    },

    en: {
        forms: {
            name: 'Name',
            email: 'Email',
            phoneNumber: 'Phone',
            dateOfBirth: 'Date of birth',
            password: 'Password',
        },
    },
};



// WEBPACK FOOTER //
// ./src/global/locales/pages.js